import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { DEFAULT_BACKGROUND_SUBTLE_HIGHLIGHT_COLOR } from '../styles/colors';
export const FormControlContainer = styled.div(({ isFlex }) => css `
    background-color: ${DEFAULT_BACKGROUND_SUBTLE_HIGHLIGHT_COLOR};
    border-radius: 10px;
    padding: 10px;
    margin-bottom: 10px;
    ${isFlex &&
    css `
      display: flex;
      flex-direction: row;
      gap: 10px;
      flex-wrap: wrap;
    `}
  `);
